import {
	createStore,
	createContainer,
	createSubscriber,
	createHook,
	type StoreActionApi,
} from '@atlassian/react-sweet-state';
import { defaultState as initialState } from '../reducer';
import type { State } from '../types';

/**
 * Actions
 */
export const updateStore =
	(newState: State) =>
	({ setState }: StoreActionApi<State>) => {
		setState(newState);
	};

export const getStoreState =
	() =>
	({ getState }: StoreActionApi<State>): State =>
		getState();

export const actions = { updateStore, getStoreState };

export type Actions = typeof actions;

/**
 * Store
 */
export const Store = createStore<State, Actions>({
	name: 'knowledge-hub',
	initialState,
	actions,
});

/**
 * Main Container
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const KnowledgeHubContainer = createContainer<State, Actions, Record<any, any>>(Store);
export type KnowledgeHubContainerType = typeof KnowledgeHubContainer;

/**
 * Main State Subscriber
 */
export const KnowledgeHubStateSubscriber = createSubscriber<
	State,
	Actions,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any>,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any>
>(Store, {
	displayName: 'KnowledgeHubState',
});
export type KnowledgeHubStateSubscriberType = typeof KnowledgeHubStateSubscriber;

/**
 * Actions Subscriber
 */
export const KnowledgeHubActionsSubscriber = createSubscriber<
	State,
	Actions,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any>,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any>
>(Store, {
	displayName: 'KnowledgeHubActions',
	selector: null,
});

export const useKnowledgeHubActions = createHook(Store, {
	selector: null,
});

export type KnowledgeHubActionsSubscriberType = typeof KnowledgeHubActionsSubscriber;
